// frontend/src/components/charts/ChartCard.jsx
import React from "react";
import PropTypes from "prop-types";

/**
 * ChartCard — titled white panel that wraps a chart, or shows an empty state.
 *
 * @param {{ title: string, isEmpty: boolean, children?: React.ReactNode }} props
 */
function ChartCard({ title, isEmpty, children = null }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      <h2 className="text-sm font-semibold text-gray-700 mb-3">{title}</h2>
      {isEmpty ? (
        <p className="text-sm text-gray-400 py-8 text-center">
          No scan data yet.
        </p>
      ) : (
        children
      )}
    </div>
  );
}
ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

export default ChartCard;
